import React from "react";
import types from '../../types';
import styles from './styles.module.scss';

const Background = ({children}) => (
  <div className={styles.background}>
    {children}
  </div>
);

Background.propTypes = {
  ...types.children
};

export default Background;
